import env from "environment";
import mobileBridge from "mobileBridge";
// export interface ICrossAppNavigationOptions {
//   path?;
//   matchEnv?: boolean;
// }

/**
 * Provides a go() helper function for contextual navigation on the web and in the app.
 */
export class NavigationSvc {
  // eslint-disable-next-line no-useless-constructor
  constructor() {}
  // constructor() {
  //   /**
  //    * Listen for messages from the host environment.
  //    */
  //   window.addEventListener("message", (e) => {
  //     switch (e.data.action) {
  //       case "update-app-path": {
  //         const current = new URL(location.href).pathname.toString();
  //         if (e.data.params.path && e.data.params.path !== current) {
  //           location.href = e.data.params.path;
  //         }
  //         break;
  //       }
  //     }
  //   });
  // }

  /**
   * Handles navigation to a specific URL based on context.
   *
   * @remarks
   * Navigates within the same tab for wwdb.com URLs, navigates with the NativeAppSvc if env.isApp is true, or opens non-WWDB links in a new tab.
   *
   * @param url - the URL to navigate to
   */
  // go(url): void {
  //   if (mobileBridge.isApp()) {
  //     if (url.indexOf("/") === 0) {
  //       location.href = url; //if relative path, redirect in the same tab
  //     } else {
  //       //url.indexOf(".wwdb.com/") !== -1
  //       mobileBridge.openLink(url); //for full URL links, let the app handles requests
  //     }
  //   } else {
  //     if (url.indexOf("/") === 0 || url.indexOf(".wwdb.com/") !== -1) {
  //       // Change page location if we're still on wwdb.com
  //       location.href = url;
  //     } else {
  //       // Open link in new tab if navigating off-site.
  //       var a = $(`<a href="${url}" target="_blank"></a>`);

  //       $("body").append(a);
  //       a[0].click();
  //       a.remove();
  //     }
  //   }
  // }

  isEmbedded() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  /**
   * Navigate from one app to another, as opposed to a different state within the same app, in a customizable and decoupled way.
   *
   * @remarks
   * Posts a message to the parent window or the NativeAppSvc for handling. Apps aren't supposed to assume anything about which
   * other apps exist and where they live, so the actual navigation is handled in the parent context where those things are known.
   *
   * @param appName - Name of the app (acts as an ID or key)
   * @param options - Options to customize aspects of the navigation
   */
  goToApp(appName, options) {
    if (
      mobileBridge.isApp() &&
      mobileBridge.hasFeature &&
      mobileBridge.hasFeature("navigate-to-app")
    ) {
      // In the native app and app is configured to handle requests. Send message through NativeAppSvc.
      mobileBridge.postMessage(
        "navigate-to-app",
        {
          appName,
          ...options,
        },
        false
      );
    }
    // else if (this.isEmbedded()) {
    //   // Embedded in the CMS. Post message to parent window.
    //   window.parent.postMessage(
    //     {
    //       action: "navigate-to-app",
    //       params: {
    //         appName,
    //         path: options.path || "/",
    //       },
    //     },
    //     "*"
    //   );
    // }
    else {
      // Not embedded - just running on its own, likely for local development. Look up URL through Core API and redirect.
      this.getAppMapEntry(appName)
        .then((entry) => {
          const url = new URL(options.path || "/", entry.url);

          if (options.matchEnv) {
            window.location.href = this.matchCurrentEnv(url.toString());
          } else {
            window.location.href = url.toString();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }

  /**
   * Looks up a single app map entry through the Core API.
   *
   * @param appName - Name of the app.
   */
  getAppMapEntry(appName) {
    return fetch(`${env.coreBffUrl}/navigation/app/${appName}`).then((res) => {
      return res.json();
    });
  }

  getAppMap() {
    return fetch(`${env.coreBffUrl}/navigation/apps`).then((res) => {
      return res.json();
    });
  }

  /**
   * Sends a message to the host environment to change the URL.
   */
  updateHostPath(path) {
    window.parent.postMessage(
      {
        action: "update-host-path",
        params: {
          path,
        },
      },
      "*"
    );
  }

  /**
   * Attempts to replace a URL's -env fragment with the fragment of the current app.
   *
   * @param url - URL to modify.
   */
  matchCurrentEnv(url) {
    const fragment = this.getURLEnvFragment(window.location.href);
    const parts = new URL(url).host.split(".");
    const domain = parts.slice(parts.length - 2).join(".");
    const subdomain = parts
      .slice(0, parts.length - 2)
      .map((p) => p.trim())
      .join(".");

    let result = new URL(url);

    if (/-(dev|staging|local)$/.test(subdomain)) {
      result.host =
        subdomain.replace(/-(dev|staging|local)$/, fragment) + "." + domain;
    } else {
      result.host = subdomain + fragment + "." + domain;
    }

    return result.toString();
  }

  /**
   * Determines the -env fragment of the URL. Returns "" for production.
   *
   * @param url - URL to parse.
   */
  getURLEnvFragment(url) {
    const parts = new URL(url).host.split(".");
    const subdomain = parts
      .slice(0, parts.length - 2)
      .map((p) => p.trim())
      .join(".");

    if (/-local$/.test(subdomain)) {
      return "-local";
    } else if (/-dev$/.test(subdomain)) {
      return "-dev";
    } else if (/-staging$/.test(subdomain)) {
      return "-staging";
    } else {
      return "";
    }
  }
}
